import { useState } from "react";
import { useNavigate } from "react-router-dom";

const FORM_URL = "https://readdy.ai/api/form/da1vu1rk8r5te5mqscmg";

const contactInfo = [
  { icon: "ri-mail-line", title: "邮箱", value: "gufengmanga@example.com" },
  { icon: "ri-time-line", title: "服务时间", value: "每日 09:00 - 22:00" },
  { icon: "ri-chat-3-line", title: "客服", value: "站内留言，专属回复" },
  { icon: "ri-question-line", title: "合作", value: "投稿 / 版权 / 商务洽谈" },
];

export default function Contact() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐检测
    const honeypot = String(data.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setSuccessMsg("感谢你的留言，我们会尽快与你联系。");
      form.reset();
      return;
    }

    data.delete("website_alt");

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = /spam/i.test(serverMsg || "");

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setSuccessMsg(serverMsg || "留言已提交成功，我们会尽快回复你。");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试。");
    }
  };

  return (
    <div>
      <section className="relative w-full overflow-hidden">
        <div className="relative h-44 w-full md:h-52">
          <img
            src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E4%BF%A1%E7%AC%BA%E9%82%AE%E7%AE%B1%E4%B8%8E%E5%86%99%E4%BF%A1%E5%B7%A5%E5%85%B7%E6%9A%97%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E8%83%8C%E6%99%AF%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=1600&height=420&seq=contact-banner-2026&orientation=landscape"
            alt="古风漫画网联系我们横幅"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 to-foreground-950/30"></div>
          <div className="relative z-10 container-x flex h-full flex-col justify-center">
            <nav className="flex items-center gap-1.5 text-sm text-background-300" aria-label="面包屑">
              <button onClick={() => navigate("/")} className="cursor-pointer hover:text-background-50">首页</button>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-accent-300">联系我们</span>
            </nav>
            <h1 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">联系我们</h1>
            <p className="mt-1.5 text-sm text-background-200">你的每一条建议，都是我们做得更好的动力</p>
          </div>
        </div>
      </section>

      <div className="container-x grid grid-cols-1 gap-8 py-12 lg:grid-cols-5">
        {/* 联系信息 */}
        <aside className="lg:col-span-2">
          <h2 className="font-heading text-xl font-bold text-foreground-950">联系方式</h2>
          <p className="mt-2 text-sm text-foreground-600">无论你想反馈建议、洽谈合作，还是单纯聊聊喜欢的漫画，都欢迎联系我们。</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
            {contactInfo.map((c) => (
              <div key={c.title} className="flex items-start gap-4 rounded-lg border border-background-300/60 bg-background-100 p-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{c.title}</p>
                  <p className="mt-0.5 text-sm text-foreground-600">{c.value}</p>
                </div>
              </div>
            ))}
          </div>
        </aside>

        {/* 表单 */}
        <div className="lg:col-span-3">
          <div className="rounded-lg border border-background-300/60 bg-background-50 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">给我们留言</h2>
            <p className="mt-1 text-sm text-foreground-500">填写下表，我们会尽快回复你（带 * 为必填项）</p>

            {status === "success" && (
              <div className="mt-5 flex items-center gap-3 rounded-md border border-secondary-300 bg-secondary-100 px-4 py-3 text-sm text-secondary-900">
                <i className="ri-checkbox-circle-line text-lg"></i>{successMsg}
              </div>
            )}
            {status === "error" && (
              <div className="mt-5 flex items-center gap-3 rounded-md border border-primary-300 bg-primary-100 px-4 py-3 text-sm text-primary-800">
                <i className="ri-error-warning-line text-lg"></i>{formError}
              </div>
            )}

            <form onSubmit={onSubmit} data-readdy-form className="mt-6 space-y-5">
              {/* 蜜罐字段 */}
              <input
                type="text"
                name="website_alt"
                className="form-honey"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="name" className="mb-1.5 block text-sm font-medium text-foreground-800">你的称呼 *</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    maxLength={30}
                    placeholder="怎么称呼你"
                    className="w-full rounded-md border border-background-300 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-foreground-800">电子邮箱 *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder="用于接收回复"
                    className="w-full rounded-md border border-background-300 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="subject" className="mb-1.5 block text-sm font-medium text-foreground-800">留言主题</label>
                <select
                  id="subject"
                  name="subject"
                  className="w-full rounded-md border border-background-300 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
                >
                  <option value="使用反馈">使用反馈</option>
                  <option value="作品投稿">作品投稿</option>
                  <option value="版权合作">版权合作</option>
                  <option value="商务洽谈">商务洽谈</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="mb-1.5 block text-sm font-medium text-foreground-800">留言内容 *</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="请描述你的想法或建议（最多 500 字）"
                  className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
                ></textarea>
                <p className="mt-1 text-right text-xs text-foreground-500">最多 500 字</p>
              </div>

              <button
                type="submit"
                disabled={status === "loading"}
                className="btn-primary w-full disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
              >
                {status === "loading" ? (
                  <><i className="ri-loader-4-line mr-1.5 animate-spin"></i>提交中...</>
                ) : (
                  <><i className="ri-send-plane-line mr-1.5"></i>提交留言</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}